import React, { ReactElement } from 'react';
import styled from 'styled-components';

interface Props {
  className?: string;
  title?: React.ReactNode;
  icon?: ReactElement;
  color?: string;
}

const Notification = ({ className = '', title = '', icon, color = '' }: Props) => (
  <div className={`${className} ${color}`}>
    {icon}
    {title}
  </div>
);

const NotificationStyled = styled(Notification)`
  display: inline-flex;
  gap: 1rem;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.333333333333333;
  border-radius: 0.125rem;
  padding: 0.75rem;
  margin: 0;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    width: 0.0625rem;
    top: 50%;
    height: 1rem;
    margin-left: 1.5rem;
    transform: translateY(-50%);
  }

  &.blue {
    background: ${({ theme }) => theme.primaryBackground};
    border-left: 0.125rem solid ${({ theme }) => theme.primaryBorder};

    svg {
      color: ${({ theme }) => theme.primaryText};
    }

    &:after {
      background-color: ${({ theme }) => theme.primaryBackgroundMedium};
    }
  }
`;

export default NotificationStyled;
